// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul[data-v-31ea2b50] {\n  column-count: 3;\n  column-gap: 2rem;\n  list-style: none;\n}\n", ""]);
// Exports
module.exports = exports;
